module.exports = __webpack_public_path__ + "media/app/assets/classes/death_knight-c523e5c461afead93bb2114b27428b10.jpg";